module.exports = "../images/homepage/timer-sport.svg";